import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const CostPage_OneCost_QueryDocument = graphql(`
  query CostPage_OneCost_Query($id: Id!) {
    findOneCost(id: $id) {
      code
      label
      ...CostPage_Tabs_Cost_Fragment
      ...ServiceUsageCardCmp_Cost_Fragment
    }
  }
`);

export type CostPage_OneCost = ResultOf<
  typeof CostPage_OneCost_QueryDocument
>['findOneCost'];

export const useFindOneCostQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(CostPage_OneCost_QueryDocument, { id }, { enabled: !!id });
